import React, { useState, useEffect } from "react";
import Icon from "../../components/em/Icon";

import { API_URL } from '../../api/api';






import { toast } from "../../utils/toast";
import { hasPermission } from "../../utils/permissionUtils";
const ShiftSwapModal = ({ employees, shifts, isReadOnly = false, onSwap, onClose }) => {
  // Whether to offer the queue at all. The cached permission is only a hint:
  // it comes from localStorage written at login, so a grant made mid-session
  // is not there yet, and it says nothing about being someone's line manager.
  // The server answers definitively via /shift-requests/can-review.
  const [canApproveSwaps, setCanApproveSwaps] = useState(
    hasPermission("approve_shift_swaps"),
  );
  const [employee1, setEmployee1] = useState("");
  const [employee2, setEmployee2] = useState("");
  const [assignmentType, setAssignmentType] = useState("single");
  const [dates, setDates] = useState([]);
  const [pendingRequests, setPendingRequests] = useState([]);
const [historyRequests, setHistoryRequests] = useState([]);
  // Creating a swap outright is a roster write (isReadOnly); seeing and
  // deciding the queue is `approve_shift_swaps` or being someone's manager.
  // Raising your own request is open to everyone — a reviewer works shifts
  // too, and had no way to ask for a swap while the queue owned the modal.
  const TABS = [
    "request",
    ...(isReadOnly ? [] : ["create"]),
    ...(canApproveSwaps ? ["pending", "history"] : []),
  ];
  const requestOnly = TABS.length === 1;
 const [activeTab, setActiveTab] = useState(TABS[0]);
const [shift1, setShift1] = useState("");
const shiftbaseURL = `${API_URL}/api/settings/shifts`; 
useEffect(() => {
  if (activeTab === "pending") fetchPending();
  if (activeTab === "history") fetchHistory();
}, [activeTab]);

// Ask the server who this is. Catches both a permission granted mid-session
// (localStorage is still stale) and a line manager who holds no permission but
// does have reports whose requests they may decide.
useEffect(() => {
  let cancelled = false;
  (async () => {
    try {
      const res = await fetch(`${shiftbaseURL}/shift-requests/can-review`, {
        headers: authHeaders(),
      });
      if (!res.ok) return;
      const data = await res.json();
      if (cancelled || !data?.canReview) return;
      // Only reveals the queue tabs — the active tab is left alone so the
      // modal never jumps out from under someone mid-interaction.
      setCanApproveSwaps(true);
    } catch {
      /* leave the cached permission as the answer */
    }
  })();
  return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);
  const addDate = e => {
    const d = e.target.value;
    if (d && !dates.includes(d)) setDates([...dates, d]);
  };

  const removeDate = d => {
    setDates(dates.filter(x => x !== d));
  };
// The request form asks only for the shift you want; the server takes the
// requester from the session. It used to also demand employee1 and a date,
// neither of which this tab collects, so it could never pass validation.
const handleRequestSubmit = () => {
  if (!shift1) {
    toast.error("Select the shift you want to swap to");
    return;
  }

  onSwap({ type: "request", requested_shift: shift1 });
};

// Auth helper for the legacy fetch calls in this modal.
const authHeaders = () => {
  const t = localStorage.getItem("token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};
const handle401 = (res) => {
  if (res.status === 401) {
    localStorage.clear();
    window.location.assign("/login");
    return true;
  }
  return false;
};

const fetchPending = async () => {
  try {
    const res = await fetch(`${shiftbaseURL}/shift-requests?status=pending`, {
      headers: authHeaders(),
    });
    if (handle401(res)) return;
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    setPendingRequests(data);
  } catch (err) {
    console.error("Failed to fetch pending shift requests", err);
    setPendingRequests([]);
  }
};

const fetchHistory = async () => {
  try {
    const res = await fetch(`${shiftbaseURL}/shift-requests?status=history`, {
      headers: authHeaders(),
    });
    if (handle401(res)) return;
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    setHistoryRequests(data);
  } catch (err) {
    console.error("Failed to fetch shift request history", err);
    setHistoryRequests([]);
  }
};

const handleApprove = async (id) => {
  try {
    const res = await fetch(`${shiftbaseURL}/shift-requests/${id}/approve`, {
      method: "POST",
      headers: authHeaders(),
    });
    if (handle401(res)) return;
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      toast.error(data.error || `Approve failed (${res.status})`);
      return;
    }
    fetchPending();
  } catch (err) {
    toast.error(err.message || "Approve failed");
  }
};

const handleReject = async (id) => {
  try {
    const res = await fetch(`${shiftbaseURL}/shift-requests/${id}/reject`, {
      method: "POST",
      headers: authHeaders(),
    });
    if (handle401(res)) return;
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      toast.error(data.error || `Reject failed (${res.status})`);
      return;
    }
    fetchPending();
  } catch (err) {
    toast.error(err.message || "Reject failed");
  }
};
const formatShortDate = date =>
  new Date(date).toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric"
  });

  const handleSubmit = () => {
    if (!employee1 || !employee2 || dates.length === 0) {
      toast.error("Fill all required fields");
      return;
    }
    if (employee1 === employee2) {
      toast.error("Employees must be different");
      return;
    }

    onSwap({
      employee1,
      employee2,
      dates,
      type: assignmentType
    });
  };

  const formatDate = d =>
    new Date(d).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric"
    });

  return (
    <div className="modal-overlay">
      <div className="swap-modal modal">

        {/* Header */}


        <div className="title-btns">
          <div className="icn-subtit">
            <span className="icon-wrap"><Icon name="swap" /></span>
            <h3>Shift Swaps</h3>
            <p>{canApproveSwaps || !isReadOnly ? "Manage shift swap requests" : "Request a shift swap"}</p>
          </div>
          <div><div className="close-btn" onClick={onClose}><Icon name="close"/></div></div>
        </div>






        {/* Tabs — hidden when the request form is the only thing on offer,
            since a lone tab is just a label that does nothing. */}
     {!requestOnly && (
     <ul className="mode-tabs">
  {TABS.map(tab => (

    <li
      key={tab}
      className={activeTab === tab ? "active" : ""}
      onClick={()=>setActiveTab(tab)}
    >
      {tab === "create" && "Create Swap"}
      {tab === "pending" && "Pending"}
      {tab === "history" && "History"}
      {tab === "request" && "Request Swap"}
    </li>
  ))}
</ul>
     )}


{activeTab === "create" && (

<div className="form-wrap">
    {/* Employees */}
    <div className="form-item">
      <p>Create a shift swap between two employees. This will automatically approve the swap.</p>
    </div>

      <div className="col-2">
      <div className="form-item">
        <label>Employee 1 *</label>
        <select value={employee1} onChange={e=>setEmployee1(e.target.value)}>
          <option value="">Select employee</option>
          {employees.map(e=>(
            <option key={e.id} value={e.id}>
              {e.first_name} {e.last_name}
            </option>
          ))}
        </select>
      </div>

      <div className="form-item">
        <label>Employee 2 *</label>
        <select value={employee2} onChange={e=>setEmployee2(e.target.value)}>
          <option value="">Select employee</option>
          {employees.map(e=>(
            <option key={e.id} value={e.id}>
              {e.first_name} {e.last_name}
            </option>
          ))}
        </select>
      </div>
    </div>
    

    {/* Assignment Type */}
    <div className="form-item">
      <label>Assignment Type *</label>
      <select value={assignmentType} onChange={e=>setAssignmentType(e.target.value)}>
        <option value="single">Single Date</option>
        <option value="multiple">Multiple Dates</option>
      </select>
    </div>

    {/* Date */}
    <div className="form-item">
      <label>Select Date *</label>
      <input type="date" onChange={addDate}/>
    </div>

    {/* Chips */}
    <div className="date-list">
      {dates.map(d=>(
        <span key={d} className="chip">
          {formatDate(d)}
          <button onClick={()=>removeDate(d)}>×</button>
        </span>
      ))}
    </div>
<div className="form-action">
    <button className="orng-fill" onClick={handleSubmit}>
      Create & Auto-Approve Swap
    </button>
  </div>
  </div>

)}
{activeTab==="request" && (


<div className="form-wrap">
  <div className="form-item">
  <label>Shift you want *</label>

  <select value={shift1} onChange={e=>setShift1(e.target.value)}>
  <option value="">Select a shift</option>
  {shifts.map(sh=>(
  <option key={sh.id} value={sh.id}>{sh.name}</option>
  ))}
  </select>
  <small>Your request goes to your manager for approval.</small>
  </div>

  <div className="form-action">
  <button onClick={handleRequestSubmit}>
  Submit Swap Request
  </button>
  </div>
</div>
)}


{activeTab==="pending" && (
  <div className="list pending-wrap">
  {!pendingRequests.length && <p>No pending requests</p>}

  {pendingRequests.map(req=>(
    <div key={req.id} className="req-row">

      <div>
        <strong>User:</strong> {req.username}
        <br/>
        <strong>Shift:</strong> {req.shift_name}
      </div>

      <div className="actions">
        <button className="org-gradi" onClick={()=>handleApprove(req.id)}>Approve</button>
        <button onClick={()=>handleReject(req.id)}>Reject</button>
      </div>

    </div>
  ))}
</div>
)}

{activeTab==="history" && (
  <div className="list history-wrap">

  {!historyRequests.length && <p>No history</p>}

  {historyRequests.map(req=>(
    <div key={req.id} className="req-row">

      <div>
        <strong>User:</strong> {req.username}
        <br/>
        <strong>Shift:</strong> {req.shift_name}
        <br/>
        <strong>Status:</strong> {req.status}
      </div>

      <small>
        Reviewed at {formatShortDate(req.reviewed_at)}
      </small>
       <small>
        Reviewed By {req.reviewed_by_name}
      </small>
    </div>
  ))}
</div>
)}
      


      </div>
    </div>
  );
};

export default ShiftSwapModal;